import React from 'react';
import { Translate as t } from '../../config/Translate';

// IMP-167: license/ 테이블 공용 컬럼 헤더 DSL.
//   col = { key, label?, style?, title?, className?, node? }
//   - key       : React diff key + 안정 식별자
//   - label     : i18n 키 (node 미지정 시 t(label) 렌더)
//   - style     : <th> style
//   - title     : i18n 키 (<th> title 툴팁). 미지정 시 title 속성 없음.
//   - className : <th> className. 미지정 시 className 속성 없음.
//   - node      : 커스텀 헤더 콘텐츠(multiline 등). 지정 시 label 무시.
//
// label 규약 (PR #342 review #2):
//   label·title 에는 항상 "i18n 키"를 넣는다. **신규 컬럼은 dotted 키 권장**
//   (예: 'common.label.company', 'license.label.issuedAt') — IMP-276 이후 표준.
//   단, CustomerLicensesTable 의 'User ID'/'Company'/'Memo' 등 평문 라벨은 lang 파일에
//   平文 flat 키로 등록된 레거시이며 t() 가 정상 해석하므로 동작상 동일. dotted 전면
//   통일은 lang 파일(다국어) 키 추가·검증을 수반하는 i18n 작업이라 별도 트랙으로 분리한다.
//   → 여기서는 "label = i18n 키, 신규는 dotted" 규약만 코드로 고정.
export const renderHeader = (cols) =>
    cols.map((c) => (
        <th
            key={c.key}
            style={c.style}
            title={c.title ? t(c.title) : undefined}
            className={c.className}
        >
            {c.node !== undefined ? c.node : t(c.label)}
        </th>
    ));
